import { useServerStatusStore } from 'stores/server-status/index.js'
import { useSiteInfoStore } from 'stores/site-info/index.js'
import { captureRegistrationCurrencySelectorAnomaly } from 'src/services/registration-observability.js'
import { rememberRegistrationSiteInfo } from 'src/services/registration-site-info-snapshot.js'

export async function insertSiteInfo(data) {
  const siteInfoStore = useSiteInfoStore()
  const serverStatusStore = useServerStatusStore()

  if (!data.siteInfo) {
    captureRegistrationCurrencySelectorAnomaly({ reason: 'site_info_missing', data })
    return
  }

  rememberRegistrationSiteInfo(data)

  const isBot = window.IS_BOT

  if (isBot) {
    captureRegistrationCurrencySelectorAnomaly({ reason: 'currencies_skipped_for_bot', data: { ...data, isBot } })
    siteInfoStore.updateSiteInfo(data.siteInfo)
    siteInfoStore.updateSumRegionRules(data.sumRegionRules)
    serverStatusStore.updateUnderDev(data.siteInfo.underDev)
    return
  }

  if (data.siteInfo.additionalRedirect) {
    location.replace(data.siteInfo.additionalRedirect)
    return
  }

  if (!Array.isArray(data.currencies)) {
    captureRegistrationCurrencySelectorAnomaly({ reason: 'currencies_not_array', data })
  } else if (data.currencies.length === 0) {
    captureRegistrationCurrencySelectorAnomaly({ reason: 'currencies_empty', data })
  }
  // else if (data.currencies.length === 1) {
  //   captureRegistrationCurrencySelectorAnomaly({ reason: 'currencies_single', data })
  // }

  siteInfoStore.updateSiteInfo(data.siteInfo)
  siteInfoStore.updateSumRegionRules(data.sumRegionRules)
  serverStatusStore.updateUnderDev(data.siteInfo.underDev)
  siteInfoStore.setCurrencyData({
    currencies: data.currencies,
    defaultCurrency: data.defaultCurrency,
  })
}
